/*
 * View for the content preview of a selected URL
 */

define([
  "marionette",
  "modules/contentsSplit/content/contentPreview/template/contentPreviewTemplate.html",
], function (Marionette, ContentPreviewTemplate) {
  var ContentPreviewView = {};

  ContentPreviewView.contentPreviewView = Marionette.ItemView.extend({
    template: ContentPreviewTemplate,
    hidePreview: function () {
      this.$el.find(".previewFrame").hide();
    },
    unhidePreview: function () {
      this.$el.find(".previewFrame").show();
    },
    onShow: function () {
      this.$el.i18n();
      //if we are loading a site in the iframe, then set up the loading spinner and prepare the fallback message
      if (
        !this.model.get("pdf") &&
        this.model.get("url") !== "" &&
        !this.model.get("downloadFlag")
      ) {
        var iFrame = this.$el.find(".previewFrame");
        var spinner = this.$el.find("#loadingPreview");
        var fallback = this.$el.find("#fallback");
        //show a spinner until the iFrame loads, then show the frame and hide the spinner
        iFrame.find("iframe").one("load", function () {
          console.log("iframe show");
          iFrame.show();
          spinner.hide();
          fallback.show();
        });
      } else {
        //show preview frame
        this.$el.find(".previewFrame").show();
      }
    },
  });

  return ContentPreviewView;
});
